export const dtdlSyntaxMap = {
    'dtmi:dtdl:class:Array;2': 'Array',
    'dtmi:dtdl:class:Boolean;2': 'Boolean',
    'dtmi:dtdl:class:ComplexSchema;2': 'ComplexSchema',
    'dtmi:dtdl:class:Command;2': 'Command',
    'dtmi:dtdl:class:CommandPayload;2': 'CommandPayload',
    'dtmi:dtdl:class:CommandType;2': 'CommandType',
    'dtmi:dtdl:class:Component;2': 'Component',
    'dtmi:dtdl:class:Content;2': 'Content',
    'dtmi:dtdl:class:Date;2': 'Date',
    'dtmi:dtdl:class:DateTime;2': 'DateTime',
    'dtmi:dtdl:class:Double;2': 'Double',
    'dtmi:dtdl:class:Duration;2': 'Duration',
    'dtmi:dtdl:class:Entity;2': 'Entity',
    'dtmi:dtdl:class:Enum;2': 'Enum',
    'dtmi:dtdl:class:EnumValue;2': 'EnumValue',
    'dtmi:dtdl:class:Field;2': 'Field',
    'dtmi:dtdl:class:Float;2': 'Float',
    'dtmi:dtdl:class:Integer;2': 'Integer',
    'dtmi:dtdl:class:Interface;2': 'Interface',
    'dtmi:dtdl:class:Long;2': 'Long',
    'dtmi:dtdl:class:Map;2': 'Map',
    'dtmi:dtdl:class:MapKey;2': 'MapKey',
    'dtmi:dtdl:class:MapValue;2': 'MapValue',
    'dtmi:dtdl:class:NamedEntity;2': 'NamedEntity',
    'dtmi:dtdl:class:NumericSchema;2': 'NumericSchema',
    'dtmi:dtdl:class:Object;2': 'Object',
    'dtmi:dtdl:class:PrimitiveSchema;2': 'PrimitiveSchema',
    'dtmi:dtdl:class:Property;2': 'Property',
    'dtmi:dtdl:class:Relationship;2': 'Relationship',
    'dtmi:dtdl:class:Schema;2': 'Schema',
    'dtmi:dtdl:class:SchemaField;2': 'SchemaField',
    'dtmi:dtdl:class:SemanticType;2': 'SemanticType',
    'dtmi:dtdl:class:SemanticUnit;2': 'SemanticUnit',
    'dtmi:dtdl:class:String;2': 'String',
    'dtmi:dtdl:class:Telemetry;2': 'Telemetry',
    'dtmi:dtdl:class:TemporalSchema;2': 'TemporalSchema',
    'dtmi:dtdl:class:Time;2': 'Time',
    'dtmi:dtdl:class:Unit;2': 'Unit',
    'dtmi:dtdl:class:UnitAttribute;2': 'UnitAttribute',
    'dtmi:standard:class:RatioUnit;2': 'RatioUnit',
    'dtmi:standard:class:DecimalUnit;2': 'DecimalUnit',
    'dtmi:standard:class:DecimalPrefix;2': 'DecimalPrefix',
    'dtmi:standard:class:BinaryUnit;2': 'BinaryUnit',
    'dtmi:standard:class:BinaryPrefix;2': 'BinaryPrefix',
    'dtmi:standard:class:QuantitativeType;2': 'QuantitativeType',
    'dtmi:standard:class:Acceleration;2': 'Acceleration',
    'dtmi:standard:class:Angle;2': 'Angle',
    'dtmi:standard:class:AngularAcceleration;2': 'AngularAcceleration',
    'dtmi:standard:class:AngularVelocity;2': 'AngularVelocity',
    'dtmi:standard:class:Area;2': 'Area',
    'dtmi:standard:class:Capacitance;2': 'Capacitance',
    'dtmi:standard:class:Current;2': 'Current',
    'dtmi:standard:class:DataRate;2': 'DataRate',
    'dtmi:standard:class:DataSize;2': 'DataSize',
    'dtmi:standard:class:Density;2': 'Density',
    'dtmi:standard:class:Distance;2': 'Distance',
    'dtmi:standard:class:ElectricCharge;2': 'ElectricCharge',
    'dtmi:standard:class:Energy;2': 'Energy',
    'dtmi:standard:class:Force;2': 'Force',
    'dtmi:standard:class:Frequency;2': 'Frequency',
    'dtmi:standard:class:Humidity;2': 'Humidity',
    'dtmi:standard:class:Illuminance;2': 'Illuminance',
    'dtmi:standard:class:Inductance;2': 'Inductance',
    'dtmi:standard:class:Latitude;2': 'Latitude',
    'dtmi:standard:class:Longitude;2': 'Longitude',
    'dtmi:standard:class:Length;2': 'Length',
    'dtmi:standard:class:Luminance;2': 'Luminance',
    'dtmi:standard:class:Luminosity;2': 'Luminosity',
    'dtmi:standard:class:LuminousFlux;2': 'LuminousFlux',
    'dtmi:standard:class:LuminousIntensity;2': 'LuminousIntensity',
    'dtmi:standard:class:MagneticFlux;2': 'MagneticFlux',
    'dtmi:standard:class:MagneticInduction;2': 'MagneticInduction',
    'dtmi:standard:class:Mass;2': 'Mass',
    'dtmi:standard:class:MassFlowRate;2': 'MassFlowRate',
    'dtmi:standard:class:Power;2': 'Power',
    'dtmi:standard:class:Pressure;2': 'Pressure',
    'dtmi:standard:class:RelativeHumidity;2': 'RelativeHumidity',
    'dtmi:standard:class:Resistance;2': 'Resistance',
    'dtmi:standard:class:SoundPressure;2': 'SoundPressure',
    'dtmi:standard:class:Temperature;2': 'Temperature',
    'dtmi:standard:class:Thrust;2': 'Thrust',
    'dtmi:standard:class:TimeSpan;2': 'TimeSpan',
    'dtmi:standard:class:Torque;2': 'Torque',
    'dtmi:standard:class:Velocity;2': 'Velocity',
    'dtmi:standard:class:Voltage;2': 'Voltage',
    'dtmi:standard:class:Volume;2': 'Volume',
    'dtmi:standard:class:VolumeFlowRate;2': 'VolumeFlowRate',
    'dtmi:standard:class:AccelerationUnit;2': 'AccelerationUnit',
    'dtmi:standard:class:AngleUnit;2': 'AngleUnit',
    'dtmi:standard:class:AngularAccelerationUnit;2': 'AngularAccelerationUni',
    'dtmi:standard:class:AngularVelocityUnit;2': 'AngularVelocityUnit',
    'dtmi:standard:class:AreaUnit;2': 'AreaUnit',
    'dtmi:standard:class:CapacitanceUnit;2': 'CapacitanceUnit',
    'dtmi:standard:class:ChargeUnit;2': 'ChargeUnit',
    'dtmi:standard:class:CurrentUnit;2': 'CurrentUnit',
    'dtmi:standard:class:DataRateUnit;2': 'DataRateUnit',
    'dtmi:standard:class:DataSizeUnit;2': 'DataSizeUnit',
    'dtmi:standard:class:DensityUnit;2': 'DensityUnit',
    'dtmi:standard:class:EnergyUnit;2': 'EnergyUnit',
    'dtmi:standard:class:ForceUnit;2': 'ForceUnit',
    'dtmi:standard:class:FrequencyUnit;2': 'FrequencyUnit',
    'dtmi:standard:class:IlluminanceUnit;2': 'IlluminanceUnit',
    'dtmi:standard:class:InductanceUnit;2': 'InductanceUnit',
    'dtmi:standard:class:LengthUnit;2': 'LengthUnit',
    'dtmi:standard:class:LuminanceUnit;2': 'LuminanceUnit',
    'dtmi:standard:class:LuminousFluxUnit;2': 'LuminousFluxUnit',
    'dtmi:standard:class:LuminousIntensityUnit;2': 'LuminousIntensityUni',
    'dtmi:standard:class:MagneticFluxUnit;2': 'MagneticFluxUnit',
    'dtmi:standard:class:MagneticInductionUnit;2': 'MagneticInductionUnit',
    'dtmi:standard:class:MassUnit;2': 'MassUnit',
    'dtmi:standard:class:MassFlowRateUnit;2': 'MassFlowRateUnit',
    'dtmi:standard:class:PowerUnit;2': 'PowerUnit',
    'dtmi:standard:class:PressureUnit;2': 'PressureUnit',
    'dtmi:standard:class:ResistanceUnit;2': 'ResistanceUnit',
    'dtmi:standard:class:SoundPressureUnit;2': 'SoundPressureUnit',
    'dtmi:standard:class:TemperatureUnit;2': 'TemperatureUnit',
    'dtmi:standard:class:TimeUnit;2': 'TimeUnit',
    'dtmi:standard:class:TorqueUnit;2': 'TorqueUnit',
    'dtmi:standard:class:Unitless;2': 'Unitless',
    'dtmi:standard:class:VelocityUnit;2': 'VelocityUnit',
    'dtmi:standard:class:VoltageUnit;2': 'VoltageUnit',
    'dtmi:standard:class:VolumeUnit;2': 'VolumeUnit',
    'dtmi:standard:class:VolumeFlowRateUnit;2': 'VolumeFlowRateUnit',
    'dtmi:dtdl:property:baseUnit;2': 'baseUnit',
    'dtmi:dtdl:property:bottomUnit;2': 'bottomUnit',
    'dtmi:dtdl:property:commandType;2': 'commandType',
    'dtmi:dtdl:property:comment;2': 'comment',
    'dtmi:dtdl:property:contents;2': 'contents',
    'dtmi:dtdl:property:description;2': 'description',
    'dtmi:dtdl:property:displayName;2': 'displayName',
    'dtmi:dtdl:property:elementSchema;2': 'elementSchema',
    'dtmi:dtdl:property:enumValue;2': 'enumValue',
    'dtmi:dtdl:property:enumValues;2': 'enumValues',
    'dtmi:dtdl:property:exponent;2': 'exponent',
    'dtmi:dtdl:property:extends;2': 'extends',
    'dtmi:dtdl:property:fields;2': 'fields',
    'dtmi:dtdl:property:mapKey;2': 'mapKey',
    'dtmi:dtdl:property:mapValue;2': 'mapValue',
    'dtmi:dtdl:property:maxMultiplicity;2': 'maxMultiplicity',
    'dtmi:dtdl:property:minMultiplicity;2': 'minMultiplicity',
    'dtmi:dtdl:property:name;2': 'name',
    'dtmi:dtdl:property:prefix;2': 'prefix',
    'dtmi:dtdl:property:properties;2': 'properties',
    'dtmi:dtdl:property:request;2': 'request',
    'dtmi:dtdl:property:response;2': 'response',
    'dtmi:dtdl:property:schema;2': 'schema',
    'dtmi:dtdl:property:schemas;2': 'schemas',
    'dtmi:dtdl:property:symbol;2': 'symbol',
    'dtmi:dtdl:property:target;2': 'target',
    'dtmi:dtdl:property:topUnit;2': 'topUnit',
    'dtmi:dtdl:property:unit;2': 'unit',
    'dtmi:dtdl:property:valueSchema;2': 'valueSchema',
    'dtmi:dtdl:property:writable;2': 'writable',
    'dtmi:dtdl:instance:CommandType:asynchronous;2': 'asynchronous',
    'dtmi:dtdl:instance:CommandType:synchronous;2': 'synchronous',
    'dtmi:dtdl:instance:Schema:boolean;2': 'boolean',
    'dtmi:dtdl:instance:Schema:date;2': 'date',
    'dtmi:dtdl:instance:Schema:dateTime;2': 'dateTime',
    'dtmi:dtdl:instance:Schema:double;2': 'double',
    'dtmi:dtdl:instance:Schema:duration;2': 'duration',
    'dtmi:dtdl:instance:Schema:float;2': 'float',
    'dtmi:dtdl:instance:Schema:integer;2': 'integer',
    'dtmi:dtdl:instance:Schema:long;2': 'long',
    'dtmi:dtdl:instance:Schema:string;2': 'string',
    'dtmi:dtdl:instance:Schema:time;2': 'time',
    'dtmi:standard:unitprefix:deci;2': 'deci',
    'dtmi:standard:unitprefix:centi;2': 'centi',
    'dtmi:standard:unitprefix:milli;2': 'milli',
    'dtmi:standard:unitprefix:micro;2': 'micro',
    'dtmi:standard:unitprefix:nano;2': 'nano',
    'dtmi:standard:unitprefix:pico;2': 'pico',
    'dtmi:standard:unitprefix:femto;2': 'femto',
    'dtmi:standard:unitprefix:atto;2': 'atto',
    'dtmi:standard:unitprefix:zepto;2': 'zepto',
    'dtmi:standard:unitprefix:yocto;2': 'yocto',
    'dtmi:standard:unitprefix:deka;2': 'deka',
    'dtmi:standard:unitprefix:hecto;2': 'hecto',
    'dtmi:standard:unitprefix:kilo;2': 'kilo',
    'dtmi:standard:unitprefix:mega;2': 'mega',
    'dtmi:standard:unitprefix:giga;2': 'giga',
    'dtmi:standard:unitprefix:tera;2': 'tera',
    'dtmi:standard:unitprefix:peta;2': 'peta',
    'dtmi:standard:unitprefix:exa;2': 'exa',
    'dtmi:standard:unitprefix:zetta;2': 'zetta',
    'dtmi:standard:unitprefix:yotta;2': 'yotta',
    'dtmi:standard:unitprefix:kibi;2': 'kibi',
    'dtmi:standard:unitprefix:mebi;2': 'mebi',
    'dtmi:standard:unitprefix:gibi;2': 'gibi',
    'dtmi:standard:unitprefix:tebi;2': 'tebi',
    'dtmi:standard:unitprefix:pebi;2': 'pebi',
    'dtmi:standard:unitprefix:exbi;2': 'exbi',
    'dtmi:standard:unitprefix:zebi;2': 'zebi',
    'dtmi:standard:unitprefix:yobi;2': 'yobi',
    'dtmi:standard:unit:metrePerSecondSquared;2': 'metrePerSecondSquared',
    'dtmi:standard:unit:centimetrePerSecondSquared;2':
        'centimetrePerSecondSquared',
    'dtmi:standard:unit:gForce;2': 'gForce',
    'dtmi:standard:unit:radian;2': 'radian',
    'dtmi:standard:unit:degreeOfArc;2': 'degreeOfArc',
    'dtmi:standard:unit:minuteOfArc;2': 'minuteOfArc',
    'dtmi:standard:unit:secondOfArc;2': 'secondOfArc',
    'dtmi:standard:unit:turn;2': 'turn',
    'dtmi:standard:unit:radianPerSecondSquared;2': 'radianPerSecondSquared',
    'dtmi:standard:unit:radianPerSecond;2': 'radianPerSecond',
    'dtmi:standard:unit:degreePerSecond;2': 'degreePerSecond',
    'dtmi:standard:unit:revolutionPerSecond;2': 'revolutionPerSecond',
    'dtmi:standard:unit:revolutionPerMinute;2': 'revolutionPerMinute',
    'dtmi:standard:unit:squareMetre;2': 'squareMetre',
    'dtmi:standard:unit:squareCentimetre;2': 'squareCentimetre',
    'dtmi:standard:unit:squareMillimetre;2': 'squareMillimetre',
    'dtmi:standard:unit:squareKilometre;2': 'squareKilometre',
    'dtmi:standard:unit:hectare;2': 'hectare',
    'dtmi:standard:unit:squareFoot;2': 'squareFoot',
    'dtmi:standard:unit:squareInch;2': 'squareInch',
    'dtmi:standard:unit:acre;2': 'acre',
    'dtmi:standard:unit:farad;2': 'farad',
    'dtmi:standard:unit:millifarad;2': 'millifarad',
    'dtmi:standard:unit:microfarad;2': 'microfarad',
    'dtmi:standard:unit:nanofarad;2': 'nanofarad',
    'dtmi:standard:unit:picofarad;2': 'picofarad',
    'dtmi:standard:unit:coulomb;2': 'coulomb',
    'dtmi:standard:unit:ampere;2': 'ampere',
    'dtmi:standard:unit:microampere;2': 'microampere',
    'dtmi:standard:unit:milliampere;2': 'milliampere',
    'dtmi:standard:unit:bitPerSecond;2': 'bitPerSecond',
    'dtmi:standard:unit:kibibitPerSecond;2': 'kibibitPerSecond',
    'dtmi:standard:unit:mebibitPerSecond;2': 'mebibitPerSecond',
    'dtmi:standard:unit:gibibitPerSecond;2': 'gibibitPerSecond',
    'dtmi:standard:unit:tebibitPerSecond;2': 'tebibitPerSecond',
    'dtmi:standard:unit:exbibitPerSecond;2': 'exbibitPerSecond',
    'dtmi:standard:unit:zebibitPerSecond;2': 'zebibitPerSecond',
    'dtmi:standard:unit:yobibitPerSecond;2': 'yobibitPerSecond',
    'dtmi:standard:unit:bytePerSecond;2': 'bytePerSecond',
    'dtmi:standard:unit:kibibytePerSecond;2': 'kibibytePerSecond',
    'dtmi:standard:unit:mebibytePerSecond;2': 'mebibytePerSecond',
    'dtmi:standard:unit:gibibytePerSecond;2': 'gibibytePerSecond',
    'dtmi:standard:unit:tebibytePerSecond;2': 'tebibytePerSecond',
    'dtmi:standard:unit:exbibytePerSecond;2': 'exbibytePerSecond',
    'dtmi:standard:unit:zebibytePerSecond;2': 'zebibytePerSecond',
    'dtmi:standard:unit:yobibytePerSecond;2': 'yobibytePerSecond',
    'dtmi:standard:unit:bit;2': 'bit',
    'dtmi:standard:unit:kibibit;2': 'kibibit',
    'dtmi:standard:unit:mebibit;2': 'mebibit',
    'dtmi:standard:unit:gibibit;2': 'gibibit',
    'dtmi:standard:unit:tebibit;2': 'tebibit',
    'dtmi:standard:unit:exbibit;2': 'exbibit',
    'dtmi:standard:unit:zebibit;2': 'zebibit',
    'dtmi:standard:unit:yobibit;2': 'yobibit',
    'dtmi:standard:unit:byte;2': 'byte',
    'dtmi:standard:unit:kibibyte;2': 'kibibyte',
    'dtmi:standard:unit:mebibyte;2': 'mebibyte',
    'dtmi:standard:unit:gibibyte;2': 'gibibyte',
    'dtmi:standard:unit:tebibyte;2': 'tebibyte',
    'dtmi:standard:unit:exbibyte;2': 'exbibyte',
    'dtmi:standard:unit:zebibyte;2': 'zebibyte',
    'dtmi:standard:unit:yobibyte;2': 'yobibyte',
    'dtmi:standard:unit:kilogramPerCubicMetre;2': 'kilogramPerCubicMetre',
    'dtmi:standard:unit:gramPerCubicMetre;2': 'gramPerCubicMetre',
    'dtmi:standard:unit:joule;2': 'joule',
    'dtmi:standard:unit:kilojoule;2': 'kilojoule',
    'dtmi:standard:unit:megajoule;2': 'megajoule',
    'dtmi:standard:unit:gigajoule;2': 'gigajoule',
    'dtmi:standard:unit:electronvolt;2': 'electronvolt',
    'dtmi:standard:unit:megaelectronvolt;2': 'megaelectronvolt',
    'dtmi:standard:unit:kilowattHour;2': 'kilowattHour',
    'dtmi:standard:unit:newton;2': 'newton',
    'dtmi:standard:unit:pound;2': 'pound',
    'dtmi:standard:unit:ounce;2': 'ounce',
    'dtmi:standard:unit:ton;2': 'ton',
    'dtmi:standard:unit:hertz;2': 'hertz',
    'dtmi:standard:unit:kilohertz;2': 'kilohertz',
    'dtmi:standard:unit:megahertz;2': 'megahertz',
    'dtmi:standard:unit:gigahertz;2': 'gigahertz',
    'dtmi:standard:unit:lux;2': 'lux',
    'dtmi:standard:unit:footcandle;2': 'footcandle',
    'dtmi:standard:unit:henry;2': 'henry',
    'dtmi:standard:unit:millihenry;2': 'millihenry',
    'dtmi:standard:unit:microhenry;2': 'microhenry',
    'dtmi:standard:unit:metre;2': 'metre',
    'dtmi:standard:unit:centimetre;2': 'centimetre',
    'dtmi:standard:unit:millimetre;2': 'millimetre',
    'dtmi:standard:unit:micrometre;2': 'micrometre',
    'dtmi:standard:unit:nanometre;2': 'nanometre',
    'dtmi:standard:unit:kilometre;2': 'kilometre',
    'dtmi:standard:unit:foot;2': 'foot',
    'dtmi:standard:unit:inch;2': 'inch',
    'dtmi:standard:unit:mile;2': 'mile',
    'dtmi:standard:unit:nauticalMile;2': 'nauticalMile',
    'dtmi:standard:unit:astronomicalUnit;2': 'astronomicalUnit',
    'dtmi:standard:unit:candelaPerSquareMetre;2': 'candelaPerSquareMetre',
    'dtmi:standard:unit:lumen;2': 'lumen',
    'dtmi:standard:unit:candela;2': 'candela',
    'dtmi:standard:unit:weber;2': 'weber',
    'dtmi:standard:unit:maxwell;2': 'maxwell',
    'dtmi:standard:unit:tesla;2': 'tesla',
    'dtmi:standard:unit:kilogram;2': 'kilogram',
    'dtmi:standard:unit:gram;2': 'gram',
    'dtmi:standard:unit:milligram;2': 'milligram',
    'dtmi:standard:unit:microgram;2': 'microgram',
    'dtmi:standard:unit:tonne;2': 'tonne',
    'dtmi:standard:unit:slug;2': 'slug',
    'dtmi:standard:unit:gramPerSecond;2': 'gramPerSecond',
    'dtmi:standard:unit:kilogramPerSecond;2': 'kilogramPerSecond',
    'dtmi:standard:unit:gramPerHour;2': 'gramPerHour',
    'dtmi:standard:unit:kilogramPerHour;2': 'kilogramPerHour',
    'dtmi:standard:unit:watt;2': 'watt',
    'dtmi:standard:unit:microwatt;2': 'microwatt',
    'dtmi:standard:unit:milliwatt;2': 'milliwatt',
    'dtmi:standard:unit:kilowatt;2': 'kilowatt',
    'dtmi:standard:unit:megawatt;2': 'megawatt',
    'dtmi:standard:unit:gigawatt;2': 'gigawatt',
    'dtmi:standard:unit:horsepower;2': 'horsepower',
    'dtmi:standard:unit:kilowattHourPerYear;2': 'kilowattHourPerYear',
    'dtmi:standard:unit:pascal;2': 'pascal',
    'dtmi:standard:unit:kilopascal;2': 'kilopascal',
    'dtmi:standard:unit:bar;2': 'bar',
    'dtmi:standard:unit:millibar;2': 'millibar',
    'dtmi:standard:unit:millimetresOfMercury;2': 'millimetresOfMercury',
    'dtmi:standard:unit:poundPerSquareInch;2': 'poundPerSquareInch',
    'dtmi:standard:unit:inchesOfMercury;2': 'inchesOfMercury',
    'dtmi:standard:unit:inchesOfWater;2': 'inchesOfWater',
    'dtmi:standard:unit:ohm;2': 'ohm',
    'dtmi:standard:unit:milliohm;2': 'milliohm',
    'dtmi:standard:unit:kiloohm;2': 'kiloohm',
    'dtmi:standard:unit:megaohm;2': 'megaohm',
    'dtmi:standard:unit:decibel;2': 'decibel',
    'dtmi:standard:unit:bel;2': 'bel',
    'dtmi:standard:unit:kelvin;2': 'kelvin',
    'dtmi:standard:unit:degreeCelsius;2': 'degreeCelsius',
    'dtmi:standard:unit:degreeFahrenheit;2': 'degreeFahrenheit',
    'dtmi:standard:unit:second;2': 'second',
    'dtmi:standard:unit:millisecond;2': 'millisecond',
    'dtmi:standard:unit:microsecond;2': 'microsecond',
    'dtmi:standard:unit:nanosecond;2': 'nanosecond',
    'dtmi:standard:unit:minute;2': 'minute',
    'dtmi:standard:unit:hour;2': 'hour',
    'dtmi:standard:unit:day;2': 'day',
    'dtmi:standard:unit:year;2': 'year',
    'dtmi:standard:unit:unity;2': 'unity',
    'dtmi:standard:unit:percent;2': 'percent',
    'dtmi:standard:unit:newtonMetre;2': 'newtonMetre',
    'dtmi:standard:unit:metrePerSecond;2': 'metrePerSecond',
    'dtmi:standard:unit:centimetrePerSecond;2': 'centimetrePerSecond',
    'dtmi:standard:unit:kilometrePerSecond;2': 'kilometrePerSecond',
    'dtmi:standard:unit:metrePerHour;2': 'metrePerHour',
    'dtmi:standard:unit:kilometrePerHour;2': 'kilometrePerHour',
    'dtmi:standard:unit:milePerHour;2': 'milePerHour',
    'dtmi:standard:unit:milePerSecond;2': 'milePerSecond',
    'dtmi:standard:unit:knot;2': 'knot',
    'dtmi:standard:unit:volt;2': 'volt',
    'dtmi:standard:unit:millivolt;2': 'millivolt',
    'dtmi:standard:unit:microvolt;2': 'microvolt',
    'dtmi:standard:unit:kilovolt;2': 'kilovolt',
    'dtmi:standard:unit:megavolt;2': 'megavolt',
    'dtmi:standard:unit:cubicMetre;2': 'cubicMetre',
    'dtmi:standard:unit:cubicCentimetre;2': 'cubicCentimetre',
    'dtmi:standard:unit:litre;2': 'litre',
    'dtmi:standard:unit:millilitre;2': 'millilitre',
    'dtmi:standard:unit:cubicFoot;2': 'cubicFoot',
    'dtmi:standard:unit:cubicInch;2': 'cubicInch',
    'dtmi:standard:unit:fluidOunce;2': 'fluidOunce',
    'dtmi:standard:unit:gallon;2': 'gallon',
    'dtmi:standard:unit:litrePerSecond;2': 'litrePerSecond',
    'dtmi:standard:unit:millilitrePerSecond;2': 'millilitrePerSecond',
    'dtmi:standard:unit:litrePerHour;2': 'litrePerHour',
    'dtmi:standard:unit:millilitrePerHour;2': 'millilitrePerHour',
    'dtmi:standard:schema:geospatial:point;2': 'point',
    'dtmi:standard:schema:geospatial:multiPoint;2': 'multiPoint',
    'dtmi:standard:schema:geospatial:lineString;2': 'lineString',
    'dtmi:standard:schema:geospatial:multiLineString;2': 'multiLineString',
    'dtmi:standard:schema:geospatial:polygon;2': 'polygon',
    'dtmi:standard:schema:geospatial:multiPolygon;': 'multiPolygon'
};
